import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { UsersService } from '../../services/users.service';

@Component({
    selector: 'app-forgot-password-component',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
    private readonly emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    email = '';
    loading = false;
    submitting = false;
    error = false;
    errorMessage = 'Unable to process your request.';
    success = false;
    successMessage = '';
    copyright = '© ' + moment().format('YYYY') + ' saferoads.ph version 1.9 Powered by Reviewmasters Inc.';

    constructor(
        private readonly userService: UsersService,
        private readonly router: Router,
        private readonly cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {}

    async requestPasswordReset(): Promise<void> {
        if (this.submitting) {
            return;
        }

        const normalizedEmail = this.email.trim();

        if (!normalizedEmail) {
            this.error = true;
            this.success = false;
            this.errorMessage = 'Email is required.';
            return;
        }

        if (!this.emailPattern.test(normalizedEmail)) {
            this.error = true;
            this.success = false;
            this.errorMessage = 'Please enter a valid email address.';
            return;
        }

        this.submitting = true;
        this.error = false;
        this.success = false;

        try {
            const response: any = await this.userService.resetpasswordByDrivingSchool({ email: normalizedEmail });

            if (response?.statusCode === 200) {
                this.success = true;
                this.successMessage = 'Password reset instructions have been sent to ' + normalizedEmail + '.';
                this.error = false;
            } else {
                this.error = true;
                this.errorMessage = 'Unable to process your request. Please try again.';
            }
        } catch (err: any) {
            const serverMessage = err?.error?.errorMessage;
            const fallbackMessage = 'Unable to process your request. Please try again.';
            this.error = true;
            this.success = false;
            this.errorMessage = Array.isArray(serverMessage)
                ? String(serverMessage[0] || fallbackMessage)
                : String(serverMessage || fallbackMessage);
        } finally {
            this.submitting = false;
            this.cdr.detectChanges();
        }
    }

    navigateToLogin(): void {
        void this.router.navigate(['/login']);
    }
}
